import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

/**
 * --------------------------------------------------------------
 * config dibaca dari env var VUE_APP_FIREBASE_* (lihat .env.example)
 * --------------------------------------------------------------
 */
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};
firebase.initializeApp(firebaseConfig);

/**
 * --------------------------------------------------------------
 * init configures config
 * --------------------------------------------------------------
 */
const db = firebase.database();
const Auth = firebase.auth();

/**
 * --------------------------------------------------------------
 * export const
 * --------------------------------------------------------------
 */
export { db, Auth, firebase };
